<div class="fui-value-list-control">

  <div class="title">{{ getTitle() }}</div>

  <ng-container *ngIf="isEmpty">
    <div class="fui-value-list-no-content">
      <ng-container *ngTemplateOutlet="isEmptyTemplate ? isEmptyTemplate: isEmptyDefaultTemplate"></ng-container>
      <button mat-flat-button color="primary" (click)="onAdd()" i18n>Add</button>
    </div>
  </ng-container>

  <form *ngIf="!isEmpty" [formGroup]="form" class="fui-value-list-content">
    <ng-container formArrayName="items" *ngFor="let item of formItemsArray.controls; let i = index">
      <div [formGroupName]="i" class="fui-keyvalue-list-item">
        <mat-form-field *ngIf="captureKeys" appearance="outline">
          <mat-label>{{ getKeyLabel() }}</mat-label>
          <input matInput formControlName="key" type="text" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ getValueLabel() }}</mat-label>
          <input matInput formControlName="value" type="text" required>
        </mat-form-field>
        <div class="actions">
          <button mat-icon-button
                 (click)="onDelete(i)"
                 [attr.aria-label]="getDeleteButtonLabel(item)"
                 class="small-icon-button">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <button mat-flat-button color="primary" (click)="onAdd()" i18n>Add</button>
  </form>
</div>

<ng-template #isEmptyDefaultTemplate>
<div class="text-muted" i18n>No metadata has been defined for this action.</div>
</ng-template>
